import * as React from "react";
import PropTypes from "prop-types";
import TileControlWrapper from "nexia_mobile/components/Controls/wrappers/TileControlWrapper";
import ThermostatDetailControls from "./ThermostatDetailControls";
import ThermostatTileControlsWrapper from "./ThermostatTileControlsWrapper";

const Thermostat = ({ isDetailed, ...props }) => {
  return isDetailed ? (
    <ThermostatDetailControls {...props} />
  ) : (
    <TileControlWrapper>
      <ThermostatTileControlsWrapper {...props} />
    </TileControlWrapper>
  );
};
Thermostat.propTypes = {
  isDetailed: PropTypes.bool.isRequired,
};

export default Thermostat;



// WEBPACK FOOTER //
// ./src/components/Controls/Thermostat/index.jsx